module.exports = __webpack_public_path__ + "static/media/processometer-one.0844c059.png";